module.exports = __webpack_public_path__ + "static/img/DSC_003.8caee0fb.png";